if (!customElements.get('carmona-mobile-purchase')) {
  customElements.define('carmona-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById(`MainProduct-${this.dataset.section}`);
      if (!this.root) return;
      this.control = this.querySelector('[data-mobile-add]');
      this.choice = this.querySelector('[data-mobile-choice]');
      this.frame = 0;
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      this.activate = () => {
        const native = this.root.querySelector('product-form button[name="add"]');
        if (!native || native.disabled || native.getAttribute('aria-disabled') === 'true') return;
        const form = native.form;
        if (!form || !form.reportValidity()) return;
        native.click();
      };
      this.control.addEventListener('click', this.activate);
      this.root.addEventListener('change', this.schedule);
      this.root.addEventListener('input', this.schedule);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.root, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value'] });
      this.visibility = new IntersectionObserver(this.schedule);
      const native = this.root.querySelector('product-form button[name="add"]');
      if (native) this.visibility.observe(native);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule, { passive: true });
      this.schedule();
    }
    update() {
      const native = this.root.querySelector('product-form button[name="add"]');
      const modal = document.querySelector('cart-notification #cart-notification.active, cart-drawer.active, dialog[open]');
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const nativeRect = native?.getBoundingClientRect();
      const primaryVisible = mobile && nativeRect && nativeRect.height > 0 && nativeRect.bottom > 0 && nativeRect.top < window.innerHeight;
      document.body.classList.toggle('carmona-primary-purchase-visible', Boolean(primaryVisible));
      const show = mobile && nativeRect && nativeRect.bottom < 0 && !modal;
      this.hidden = !show;
      document.body.classList.toggle('carmona-mobile-purchase-visible', Boolean(show));
      if (!native) return;
      this.control.disabled = native.disabled || native.getAttribute('aria-disabled') === 'true';
      const label = native.querySelector('span:not(.hidden)')?.textContent.trim() || native.textContent.trim();
      if (this.control.textContent !== label) this.control.textContent = label;
      const picker = this.root.querySelector('variant-selects');
      const options = picker ? Array.from(picker.querySelectorAll('select, input[type="radio"]:checked')).map(el => el.value).join(' · ') : '';
      const quantity = this.root.querySelector('input[name="quantity"]')?.value || '1';
      const unit = this.root.querySelector('[data-carmona-unit-price]')?.textContent.trim() || '';
      const choice = [options, `× ${quantity}`, unit ? `${unit} ${this.dataset.unitLabel}` : ''].filter(Boolean).join(' · ');
      if (this.choice.textContent !== choice) this.choice.textContent = choice;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.visibility?.disconnect();
      this.root?.removeEventListener('change', this.schedule);
      this.root?.removeEventListener('input', this.schedule);
      this.control?.removeEventListener('click', this.activate);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      document.body.classList.remove('carmona-mobile-purchase-visible', 'carmona-primary-purchase-visible');
    }
  });
}
